/**
* AppDebugInstaller.js
* 
* Created 2021-06-11
*
* @author Henrique Campos
**/

/////////////
//////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////
import AbstractInstaller from './AbstractInstaller.js';


export default class AppDebugInstaller extends AbstractInstaller {

    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

/////////////////////
/////////////////////////
///////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
//////////////////
    };

}